import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { findParentMode as t, getOppositeMode as n, getRootContrast as r, getRootMode as i } from "./utils.js";
import { DT_MODE_ISLAND_TYPES as a } from "./mode-island-constants.js";
import { modeValidator as o } from "./validators.js";
import { createBlock as s, openBlock as c, renderSlot as l, resolveDynamicComponent as u, withCtx as d } from "vue";
//#region components/mode_island/mode_island.vue
var f = {
	name: "DtModeIsland",
	compatConfig: { MODE: 3 },
	provide() {
		return { dtModeIslandMode: () => this.computedMode };
	},
	inject: { parentModeIslandMode: {
		from: "dtModeIslandMode",
		default: null
	} },
	props: {
		as: {
			type: String,
			default: "div"
		},
		mode: {
			type: String,
			default: a.INVERTED,
			validator: o
		}
	},
	data() {
		return {
			currentContrast: r(),
			contrastObserver: null,
			modeObserver: null,
			elementRef: null,
			calculatedMode: null
		};
	},
	computed: {
		isInverted() {
			return this.mode === a.INVERTED;
		},
		invertedAttribute() {
			return this.isInverted ? "" : null;
		},
		computedMode() {
			return this.mode === a.LIGHT || this.mode === a.DARK ? this.mode : this.mode === a.INVERTED && this.calculatedMode ? this.calculatedMode : this.calculateInvertedMode();
		}
	},
	beforeCreate() {
		if (this.$attrs && this.$attrs["data-dt-brand"]) throw Error("[DtModeIsland] The data-dt-brand attribute is not allowed on mode islands. Brand should only be set at the root level.");
	},
	mounted() {
		this.elementRef = this.$el, this.setupContrastObserver(), this.isInverted && (this.calculatedMode = this.calculateInvertedMode(), this.setupModeObserver()), this.currentContrast = r();
	},
	beforeUnmount() {
		this.contrastObserver && (this.contrastObserver.disconnect(), this.contrastObserver = null), this.modeObserver && (this.modeObserver.disconnect(), this.modeObserver = null);
	},
	methods: {
		calculateInvertedMode() {
			return this.parentModeIslandMode ? n(typeof this.parentModeIslandMode == "function" ? this.parentModeIslandMode() : this.parentModeIslandMode) : this.elementRef ? n(t(this.elementRef)) : n(i());
		},
		setupContrastObserver() {
			this.contrastObserver = new MutationObserver((e) => {
				for (let t of e) t.type === "attributes" && t.attributeName === "data-dt-contrast" && (this.currentContrast = r());
			}), this.contrastObserver.observe(document.documentElement, {
				attributes: !0,
				attributeFilter: ["data-dt-contrast"]
			});
		},
		setupModeObserver() {
			let e = {
				attributes: !0,
				attributeFilter: ["data-dt-mode"],
				subtree: !1
			};
			this.modeObserver = new MutationObserver((e) => {
				for (let t of e) t.type === "attributes" && t.attributeName === "data-dt-mode" && (this.calculatedMode = this.calculateInvertedMode());
			}), this.modeObserver.observe(document.documentElement, e);
			let t = this.elementRef?.parentElement;
			for (; t;) t.hasAttribute("data-dt-mode") && this.modeObserver.observe(t, e), t = t.parentElement;
		}
	}
};
function p(e, t, n, r, i, a) {
	return c(), s(u(n.as), {
		class: "d-mode-island",
		"data-dt-mode": a.computedMode,
		"data-mode-island-inverted": a.invertedAttribute,
		"data-dt-contrast": i.currentContrast
	}, {
		default: d(() => [l(e.$slots, "default")]),
		_: 3
	}, 8, [
		"data-dt-mode",
		"data-mode-island-inverted",
		"data-dt-contrast"
	]);
}
var m = /* @__PURE__ */ e(f, [["render", p]]);
//#endregion
export { m as default };

//# sourceMappingURL=mode-island.js.map